import { createSlotRecipe } from './runtime';

const tooltipConfig = {"name":"tooltip","slots":["trigger","arrow","arrowTip","positioner","content"]}

export const tooltip = /* @__PURE__ */ createSlotRecipe(tooltipConfig)